export const PKG_NAME = '@supabase/auth-helpers-sveltekit';
export const PKG_VERSION = '0.8.7';
